import { object, string } from "yup";

export type DealRepair = {
	id: number;
	itemCategory: string;
	itemName: string;
	manufacturer: string;
	modelNumber: string;
	modelNumberFile: string | null;
	requestContent: string;
};

export type DealRepairParam = {
	checkDestroy: boolean;
	itemCategory: string;
	itemName: string;
	manufacturer: string;
	modelNumber: string;
	modelNumberFile: File | null;
	requestContent: string;
};

export type DealFormRepairParam = Omit<DealRepairParam, "checkDestroy">;

export const validationSchema = object().shape({
	itemCategory: string().required("入力してください"),
	requestContent: string().required("入力してください")
});
